import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CellRange, CellType, FlexGrid } from "@grapecity/wijmo.grid";
import { Menu } from '@grapecity/wijmo.input';
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { ClassCodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component";
import { CodeComboBoxComponent } from "src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component";
import { GetClassBuyerIdService } from "./api-services/get-class-buyer-id.service";
import { GetGoodsProposalInfoService } from "./api-services/get-goods-proposal-info.service";
import { GetProposalIdService } from "./api-services/get-proposal-id.service";
import { UpdateSuggestionStatusService } from "./api-services/update-suggestion-status.service";
import { KYMW6900Model } from "./kymw6900.model";
import { GetSuggestionGoodsOutputService } from "./api-services/get-suggestion-goods-output.service";
import { FileDownloadConfirmService } from "src/app/commons/kymw02/file-download-confirm/file-download-confirm.service";
import { KYMW1102Component } from "../../kymw11/kymw1102/kymw1102.component";
import { KYMW6901Model } from "../kymw6901/kymw6901.model";
import { PlessAlert } from "../../../shared/pless-alert/pless-alert.component";


/**
 * 商品提案検索画面を管理するクラス
 *
 * @export KYMW6900Component
 * @class KYMW6900Component
 */
@Component({
  selector: 'app-kymw6900',
  templateUrl: 'kymw6900.component.html',
  styleUrls: ['kymw6900.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6900Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('cmb_ProposalStatus', { static: true }) cmb_ProposalStatus: CodeComboBoxComponent;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_MasterInputStatus', { static: true }) cmb_MasterInputStatus: CodeComboBoxComponent;
  @ViewChild('dtg_ProposalList', { static: true }) dtg_ProposalList: FlexGrid;

  public kymw6900Model = new KYMW6900Model();
  private contextMenu: Menu;

  private readonly FILE_NAME_PREFIX = '提案商品一覧表';
  private readonly FILE_NAME_SUFFIX = '.xls';

  private lastGridWidth = 0;  // 表の長さ保持用
  private baseColumnWidth_Status = 0; // 「マスタ入力」列の横幅初期値
  private resizeObserver!: ResizeObserver;

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    protected kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getProposalIdService: GetProposalIdService,
    private getClassBuyerIdService: GetClassBuyerIdService,
    private getGoodsProposalInfoService: GetGoodsProposalInfoService,
    private updateSuggestionStatusService: UpdateSuggestionStatusService,
    private getSuggestionGoodsOutputService: GetSuggestionGoodsOutputService
  ) {
    super(kymw00Model);
  }

  ngOnInit(): void {
    this.componentName = 'KYMW6900';

    this.kymw6900Model.loginUser = {
      userId: this.kymw00Model.kymw1001Model.loginUserInfo.UserID,
      associatedUserType: this.kymw00Model.kymw1001Model.loginUserInfo.AssociatedUserType,
      userClassList: this.kymw00Model.kymw1001Model.loginUserInfo.UserClassList.map(_ => {
        return {
          classCode: _.ClassCode,
          userClass: _.UserClass
        }
      })
    };

    this.dtg_ProposalList.itemsSourceChanged.addHandler(() => {
      this.dtg_ProposalList.select(-1, -1);
    });
    this.setCellClickable();
    this.setContextMenu();

    this.getProposalIdService.execute(this.kymw6900Model);

    if (this.kymw6900Model.isBuyer()) {
      this.getBuyerInfo();
    }

    this.cmb_ProposalStatus.setFocus();

    // kymw6901から受け取った検索条件を格納
    this.route.queryParams.subscribe((queryParams) => {
      if ('searchProposalStatus' in queryParams) {
        this.kymw6900Model.searchParams.proposalStatus = queryParams['searchProposalStatus'];
      }
      if ('searchClassCode' in queryParams) {
        this.kymw6900Model.searchParams.classCode = queryParams['searchClassCode'];
        this.eventClassCode_CHANGEHandler();
      }
      if ('searchProposalUserId' in queryParams) {
        this.kymw6900Model.searchParams.proposalUserId = queryParams['searchProposalUserId'];
      }
      if ('searchBuyerId' in queryParams) {
        this.kymw6900Model.searchParams.buyerId = queryParams['searchBuyerId'];
      }
      if ('searchGoodsAndStandardName' in queryParams) {
        this.kymw6900Model.searchParams.goodsNameAndStandardName = queryParams['searchGoodsAndStandardName'];
      }
      if ('searchStartOrderCode' in queryParams) {
        this.kymw6900Model.searchParams.preferredStartOrderCode = queryParams['searchStartOrderCode'];
      }
      if ('searchDelivCatalogId' in queryParams) {
        this.kymw6900Model.searchParams.preferredDelivCatalogId = queryParams['searchDelivCatalogId'];
      }
      if ('searchPCode' in queryParams) {
        this.kymw6900Model.searchParams.pcode = queryParams['searchPCode'];
      }
      if ('searchMasterInputStatus' in queryParams) {
        this.kymw6900Model.searchParams.masterInputStatus = queryParams['searchMasterInputStatus'];
      }
      // 遷移前に検索していた場合再検索
      for (const key of Object.keys(queryParams)) {
        if (queryParams[key]) {
          // コンボボックスの読み込みのためsetTimeout使用
          setTimeout(() => {
            this.eventSearch_CLICKHandler();
          }, 500);
          break;
        }
      }
    });
  }

  ngAfterViewInit() {
    let timeout: any;
    let refId: number | null = null;
    // メニュー開閉時のリサイズ監視用
    this.resizeObserver = new ResizeObserver(() => {
      clearTimeout(timeout);
      if (refId !== null) {
        cancelAnimationFrame(refId);
      }
      timeout = setTimeout(() => {
        refId = requestAnimationFrame(() => {
          refId = null;
          this.resizeFlexColumnWidth();
        })
      }, 50)
    });

    // 監視対象は商品提案一覧
    this.resizeObserver.observe(this.dtg_ProposalList.hostElement);
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }

  /**
   * 画面左メニューを開閉時に表を調整する
   * 
   */
  private resizeFlexColumnWidth(): void {
    const grid = this.dtg_ProposalList;
    const ch = grid.hostElement.querySelector('[wj-part="ch"]') as HTMLElement;
    const afterWidth = ch.clientWidth;  // リサイズ後のヘッダ横幅

    // 初期表示時は値保持のみ
    if (this.lastGridWidth === 0) {
      this.baseColumnWidth_Status = this.dtg_ProposalList.columns.getColumn('masterInputStatus').renderWidth;
      this.lastGridWidth = afterWidth;
      return;
    }

    // リサイズ前の列合計幅
    let totalColumnsWidth = 0;
    grid.columns.forEach(col => {
      totalColumnsWidth += col.renderWidth;
    });

    const extraWidth = afterWidth - totalColumnsWidth;
    if (extraWidth === 0) {
      return;
    }
    // 余白を「マスタ入力表」の1列に加算
    const targetCol = grid.columns.getColumn('masterInputStatus');
    targetCol.width = Math.max(targetCol.renderWidth + extraWidth, this.baseColumnWidth_Status);

    this.lastGridWidth = afterWidth;
  }

  private setCellClickable() {
    this.dtg_ProposalList.hostElement.addEventListener('click', (e) => {
      const ht = this.dtg_ProposalList.hitTest(e);
      if (this.kymw6900Model.isClient()) {
        if (ht.cellType === CellType.Cell && ht.col === 0) {
          const proposalId = this.kymw6900Model.proposalList[ht.row].proposalId;
          this.eventChangePropposalRadio_CLICKHandler(proposalId);
        }
        return;
      }

      if (this.kymw6900Model.isBuyer() || this.kymw6900Model.isGroupLeader()) {
        if (ht.cellType === CellType.ColumnHeader && ht.col === 0) {
          this.eventChangeHeader_CLICKHandler();
          return;
        }
        if (ht.cellType === CellType.Cell && ht.col === 0) {
          const proposalId = this.kymw6900Model.proposalList[ht.row].proposalId;
          this.eventChangePropposalCheck_CLICKHandler(proposalId);
        }
      }
    });
  }

  private setContextMenu() {
    this.createContextMenu();
    this.dtg_ProposalList.hostElement.addEventListener('contextmenu', (e: MouseEvent) => {
      e.preventDefault();
      if (!this.contextMenu) {
        return;
      }
      const ht = this.dtg_ProposalList.hitTest(e);
      if (ht.cellType === CellType.Cell) {
        const grid = new CellRange(ht.row, ht.col);
        this.dtg_ProposalList.select(grid, false);
        this.contextMenu.show(e);
      }
    });
  }

  private createContextMenu() {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        {
          header: '商品提案詳細',
          caption: '商品提案詳細',
          cmd: 'proposalDetails',
          enabled: true
        },
        {
          header: 'マスタ入力表詳細',
          caption: 'マスタ入力表詳細',
          cmd: 'masterInputDetails',
          enabled: true
        },
      ],
      itemClicked: () => {
        if (this.contextMenu.selectedValue === 'proposalDetails') {
          this.eventProposalDetails_CLICKHandler();
          return;
        }
        if (this.contextMenu.selectedValue === 'masterInputDetails') {
          this.eventMasterInputDetails_CLICKHandler();
          return;
        }
      }
    });
  }

  private eventProposalDetails_CLICKHandler() {
    const selectedItem = this.kymw6900Model.proposalList[this.dtg_ProposalList.selection.row];
    if (selectedItem) {
      this.navigateKYMW6901({
        proposalId: selectedItem.proposalId,
        proposalStatus: selectedItem.proposalStatus.code,
        masterInputId: selectedItem.masterInputId,
        tab: KYMW6901Model.TAB_PROPOSAL,
        mode: KYMW6901Model.DISPLAY_MODE_UPDATE,
        pcode: selectedItem.pcode,
        itemCode: selectedItem.itemCode,
        classCode: selectedItem.classCode.substring(0, selectedItem.classCode.indexOf(':')),    // 部門コードだけ渡す
      });

    }
  }

  private eventMasterInputDetails_CLICKHandler() {
    const selectedItem = this.kymw6900Model.proposalList[this.dtg_ProposalList.selection.row];
    if (selectedItem) {
      this.navigateKYMW6901({
        proposalId: selectedItem.proposalId,
        proposalStatus: selectedItem.proposalStatus.code,
        masterInputId: selectedItem.masterInputId,
        tab: KYMW6901Model.TAB_MASTER_INPUT,
        mode: KYMW6901Model.DISPLAY_MODE_UPDATE,
        pcode: selectedItem.pcode,
        itemCode: selectedItem.itemCode,
        classCode: selectedItem.classCode.substring(0, selectedItem.classCode.indexOf(':')),    // 部門コードだけ渡す,
      });
    }
  }

  private navigateKYMW6901(queryParams: {
    // 検索で取得した提案ID
    proposalId: string;
    proposalStatus: string;
    // 検索で取得したマスタ入力表ID
    masterInputId: string;
    tab: string;
    mode: (typeof KYMW6901Model.DISPLAY_MODE_REGIST | typeof KYMW6901Model.DISPLAY_MODE_UPDATE);
    //検索で取得したPコード
    pcode: string;
    // 検索で取得したアイテムコード    
    itemCode: string;
    // 検索で取得した部門
    classCode: string;
  }) {
    this.router.navigate(['kymw/6901'], {
      queryParams: {
        proposalId: queryParams.proposalId,
        proposalStatus: queryParams.proposalStatus,
        masterInputId: queryParams.masterInputId,
        defaultTab: queryParams.tab,
        mode: queryParams.mode,
        pcode: queryParams.pcode,
        itemCode: queryParams.itemCode,
        classCode: queryParams.classCode,
        // 検索条件
        searchProposalStatus: this.kymw6900Model.afterSearchParams.proposalStatus,
        searchClassCode: this.kymw6900Model.afterSearchParams.classCode,
        searchProposalUserId: this.kymw6900Model.afterSearchParams.proposalUserId,
        searchBuyerId: this.kymw6900Model.afterSearchParams.buyerId,
        searchGoodsAndStandardName: this.kymw6900Model.afterSearchParams.goodsNameAndStandardName,
        searchStartOrderCode: this.kymw6900Model.afterSearchParams.preferredStartOrderCode,
        searchDelivCatalogId: this.kymw6900Model.afterSearchParams.preferredDelivCatalogId,
        searchPCode: this.kymw6900Model.afterSearchParams.pcode,
        searchMasterInputStatus: this.kymw6900Model.afterSearchParams.masterInputStatus
      }
    });
  }


  private getBuyerInfo() {
    const buyerClassCode = this.kymw6900Model.loginUser.userClassList.find(userClass => userClass.userClass !== KYMW6900Model.USER_CLASS_LEADER)?.classCode;
    if (buyerClassCode) {
      this.getClassBuyerIdService.execute(buyerClassCode, (buyerList) => {
        const buyer = buyerList.find(buyer => buyer.UserId === this.kymw6900Model.userId());
        if (buyer) {
          this.kymw6900Model.searchParams.buyerId = buyer.UserId;
          this.kymw6900Model.setBuyerName(buyer.UserNmKanji);
        }
      });
    }
  }


  eventClassCode_CHANGEHandler() {
    // バイヤーの場合、部門が変更されても商品担当者は固定
    if (this.kymw6900Model.isBuyer()) {
      return;
    }

    this.kymw6900Model.clearbuyer();
    this.getClassBuyerIdService.execute(this.kymw6900Model.searchParams.classCode, (buyerList) => {
      this.kymw6900Model.updateBuyerList(buyerList);
    });
  }

  /**
   * 検索ボタン押下時のメソッド
   * @returns 
   */
  eventSearch_CLICKHandler() {
    const error = this.kymw6900Model.searchParams.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, error.message);
      return;
    }

    // 検索押下時の検索条件を保持
    this.kymw6900Model.setAfterSearchParams();

    this.kymw6900Model.setLists(this.cmb_ProposalStatus.model.codeList, this.cmb_MasterInputStatus.model.codeList, this.cmb_ClassCode.model.classList);

    this.kymw6900Model.clearSelectedProposalIds();
    this.kymw6900Model.confirmedSearchParams = this.kymw6900Model.searchParams.copy();
    this.getGoodsProposalInfoService.execute(this.kymw6900Model, 1);
  }

  eventBack_CLICKHandler() {
    this.kymw6900Model.clearSelectedProposalIds();
    this.getGoodsProposalInfoService.execute(this.kymw6900Model, this.kymw6900Model.pagenation.prevPageNum());
  }

  eventNext_CLICKHandler() {
    this.kymw6900Model.clearSelectedProposalIds();
    this.getGoodsProposalInfoService.execute(this.kymw6900Model, this.kymw6900Model.pagenation.nextPageNum());
  }

  eventChangePropposalRadio_CLICKHandler(proposalId: string) {
    this.kymw6900Model.selectedProposalIds = [proposalId];
  }

  eventChangeHeader_CLICKHandler() {
    if (!this.kymw6900Model.isHeaderChecked) {
      this.kymw6900Model.selectAllProposalIds();
    } else {
      this.kymw6900Model.clearSelectedProposalIds();
    }
  }

  eventChangePropposalCheck_CLICKHandler(proposalId: string) {
    if (this.kymw6900Model.isSelected(proposalId)) {
      this.kymw6900Model.selectedProposalIds = this.kymw6900Model.selectedProposalIds.filter(s => s !== proposalId);
    } else {
      this.kymw6900Model.selectedProposalIds = [...this.kymw6900Model.selectedProposalIds, proposalId];
    }
    this.kymw6900Model.updateIsHeaderChecked();
  }

  eventCreateProposal_CLICKHandler() {
    this.navigateKYMW6901({
      proposalId: '',
      proposalStatus: '',
      masterInputId: '',
      tab: KYMW6901Model.TAB_PROPOSAL,
      mode: KYMW6901Model.DISPLAY_MODE_REGIST,
      pcode: '',
      itemCode: '',
      classCode: '',
    });
  }

  eventCopyProposal_CLICKHandler() {
    if (PlessViewUtilsSub.isEmptyArray(this.kymw6900Model.selectedProposalIds)) {
      this.dialogService.openAlertGetMessage('W0040');
      return;
    }
    if (this.kymw6900Model.selectedProposalIds.length > 1) {
      this.dialogService.openAlertGetMessage('W0041');
      return;
    }

    const copiedId = this.kymw6900Model.selectedProposalIds[0];
    this.navigateKYMW6901({
      proposalId: copiedId,
      proposalStatus: '',
      masterInputId: '',
      tab: KYMW6901Model.TAB_PROPOSAL,
      mode: KYMW6901Model.DISPLAY_MODE_REGIST,
      pcode: '',
      itemCode: '',
      classCode: '',
    });
  }

  eventOutputProposal_CLICKHandler() {
    if (PlessViewUtilsSub.isEmptyArray(this.kymw6900Model.selectedProposalIds)) {
      this.dialogService.openAlertGetMessage('W0040');
      return;
    }
    this.getSuggestionGoodsOutputService.execute(this.kymw6900Model, this.kymw6900Model.selectedProposalIds, (fileUrl) => {
      if (!fileUrl) {
        this.dialogService.openAlertGetMessage('E0100');
        return;
      }
      this.fileDownloadConfirmService.show(fileUrl, this.getFileName());
    });
  }

  private getFileName() {
    return `${this.FILE_NAME_PREFIX}_${PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss')}${this.FILE_NAME_SUFFIX}`;
  }

  eventOutputHandling_CLICKHandler() {
    if (PlessViewUtilsSub.isEmptyArray(this.kymw6900Model.selectedProposalIds)) {
      this.dialogService.openAlertGetMessage('W0040');
      return;
    }
    this.openKYMW1102();
  }

  private openKYMW1102() {
    const pcodeList = this.kymw6900Model.proposalList.filter(
      propsal => this.kymw6900Model.selectedProposalIds.includes(propsal.proposalId) && !PlessViewUtilsSub.isEmpty(propsal.pcode)).map(proposal => proposal.pcode);
    if (PlessViewUtilsSub.isEmptyArray(pcodeList)) {
      this.dialogService.openAlertGetMessage('E0100');
      return;
    }
    const componentRef = this.dialogService.openModal(KYMW1102Component);
    const instance = componentRef.componentInstance as KYMW1102Component;
    instance.parent = this;
    instance.pcodeList = pcodeList;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  eventRejectProposal_CLICKHandler() {
    if (PlessViewUtilsSub.isEmptyArray(this.kymw6900Model.selectedProposalIds)) {
      this.dialogService.openAlertGetMessage('W0040');
      return;
    }
    if (!this.kymw6900Model.isBuyerApproved()) {
      this.dialogService.openAlertGetMessage('W0042');
      return;
    }
    this.updateSuggestionStatusService.execute(this.kymw6900Model, KYMW6900Model.PROPOSAL_STATUS_LEADER_REJECTED, () => {
      this.dialogService.openAlertGetMessage('I0106', ['却下が完了'], (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          // 「はい」を押下したら再描画する
          this.getGoodsProposalInfoService.execute(this.kymw6900Model, this.kymw6900Model.pagenation.currentPageNum());
        }
      });
    });
  }

  eventApproveProposal_CLICKHandler() {
    if (PlessViewUtilsSub.isEmptyArray(this.kymw6900Model.selectedProposalIds)) {
      this.dialogService.openAlertGetMessage('W0040');
      return;
    }
    if (!this.kymw6900Model.isBuyerApproved()) {
      this.dialogService.openAlertGetMessage('W0042');
      return;
    }

    this.updateSuggestionStatusService.execute(this.kymw6900Model, KYMW6900Model.PROPOSAL_STATUS_LEADER_APPROVED, () => {
      this.dialogService.openAlertGetMessage('I0106', ['承認が完了'], (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          // 「はい」を押下したら再描画する
          this.getGoodsProposalInfoService.execute(this.kymw6900Model, this.kymw6900Model.pagenation.currentPageNum());
        }
      });
    });
  }
}